import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FirmenstandortDto } from "@app/dto/firmenstandort.dto";
import { FirmenstandortHistoryDto } from "@app/dto/firmenstandort.history.dto";
import { FirmenstandortTransactionDto } from "@app/dto/firmenstandort.transaction.dto";
import { FirmenstandorteIndexResponseDto } from "@app/dto/firmenstandorte.index.response.dto";
import { PcAdresseDto } from "@app/dto/pcadresse.dto";
import { PcAdresseHistoryDto } from "@app/dto/pcadresse.history.dto";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FirmenstandorteService {
  private _baseUrl = `${environment.apiHost}/${environment.apiBaseUrl}`;

  public constructor(
    private readonly http: HttpClient,
  ) { }

  public getFirmenstandorte(search: string, searchFields: string, searchMode: string, queryType: string,
    orderby: string, top: number, skip: number, count: boolean, filter: string): Observable<FirmenstandorteIndexResponseDto> {
    return this.http.get<FirmenstandorteIndexResponseDto>(`${this._baseUrl}/firmenstandorte`, {
      params: {
        search, searchFields, searchMode, queryType, orderby, top, skip, count, filter
      }
    });
  }

  public patchFirmenstandort(firmenstandortId: number, patchValue: FirmenstandortDto): Observable<string> {
    return this.http.patch<string>(`${this._baseUrl}/firmenstandorte/${firmenstandortId}`, patchValue);
  }

  public getPcAdressenByFirmenstandortId(firmenstandortId: number, filter: string): Observable<PcAdresseDto[]> {
    return this.http.get<PcAdresseDto[]>(`${this._baseUrl}/firmenstandorte/${firmenstandortId}/pcadressen`, { params: { filter } });
  }

  public getFirmenstandortTransactions(firmenstandortId: number, take: number, skip: number): Observable<FirmenstandortTransactionDto[]> {
    return this.http.get<FirmenstandortTransactionDto[]>(`${this._baseUrl}/firmenstandorte/${firmenstandortId}/transaktionen`, { params: { take, skip } });
  }

  public getFirmenstandortHistory(firmenstandortId: number, take: number, skip: number): Observable<FirmenstandortHistoryDto> {
    return this.http.get<FirmenstandortHistoryDto>(`${this._baseUrl}/firmenstandorte/${firmenstandortId}/historie`, { params: { take, skip } });
  }

  public getPcAdressenHistory(firmenstandortId: number, take: number, skip: number): Observable<PcAdresseHistoryDto[]> {
    return this.http.get<PcAdresseHistoryDto[]>(`${this._baseUrl}/firmenstandorte/${firmenstandortId}/pcadressenhistorie`, { params: { take, skip } });
  }

}  